<div class="closeButton" >
    <button mat-icon-button [mat-dialog-close]="true">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div id="reportBoard">
    <div id="loginCard">
        <form [formGroup]="contactFormGroup" id="contactFormGroup" align="center">
            <mat-card  class="loginMatCard">
                <h1 mat-dialog-title>{{'keyword_$224' | translate}} "{{board_name}}"</h1>
            <div mat-dialog-content>
              <p>{{'keyword_$225' | translate}}</p>
              <mat-form-field >
                <mat-label> {{getCurrentUserLiveRequest['user_name']}} {{'keyword_$226' | translate}}</mat-label>
                <input matInput
                formControlName="message">
              </mat-form-field>
            </div>
            <div mat-dialog-actions align="center">
              <button mat-button class="requestButton" (click)="onNoClick()">{{'keyword_$228' | translate}}</button>
              <button mat-button class="requestButtonClose" color="warn" cdkFocusInitial (click)="submit(board_id)" >{{'keyword_$227' | translate}}</button>
            </div>
            </mat-card>
        </form>
    </div>
</div>
